import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {
  NavigationRecommendationsView,
  NavigationRecommendationsViewProps,
} from './NavigationRecommendationsView';
import {useRequestDrawerRecommendations} from './useRequestDrawerRecommendations';

const MemoizedNavigationRecommendationsView = React.memo(
  NavigationRecommendationsView,
);

export const NavigationRecommendations: React.FC<
  Pick<NavigationRecommendationsViewProps, 'wrapperComp' | 'isVisible'>
> = props => {
  return (
    <DataFetcher
      request={useRequestDrawerRecommendations()}
      Loading={Skeleton}
      Error={() => null}
      View={MemoizedNavigationRecommendationsView}
      viewProps={props}
    />
  );
};

const Skeleton = () => {
  return (
    <SkeletonWrapper>
      <SkeletonBlock $height="15px" />
      <SkeletonBlock $height="25px" />
      <SkeletonBlock $height="200px" />
      <SkeletonBlock $height="15px" />
      <SkeletonBlock $height="25px" />
      <SkeletonBlock $height="200px" />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  padding: 0 20px;
`;
